import { useEffect } from 'react';
import { useIntl } from 'react-intl';
// import { Form } from 'antd';
import { Helmet } from 'react-helmet';
import { PageProps } from '@/types/PageProps';
import { DefaultRouteTabs } from '@/components/_common';
// import { getUserDataFromToken, getUserFromLocalStorage } from '@/utils/user';
import { Space } from 'antd';
import ButtonPartsLink24 from '@/components/_common/ButtonPartsLink24';
import { useUserTokenPl24 } from '@/core/domain/enterprise/Users/Users.hooks';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
// import PurchasesPartsLink from '@/components/Movements/PurchasesPartsLink';

function PurchasingPartsLinkPage({ route }: PageProps) {
  const intl = useIntl();

  const { data } = useUserTokenPl24();

  useEffect(() => {
    if (
      !!data?.token &&
      hasPermissions([Authorities.MOVIMENTATION_PURCHASE_PARTSLINK24])
    ) {
      window.open(
        `https://www.oic.net.br/integradorUltraCarOiC/index.aspx?token=${data.token}`,
        '_blank',
      );
    }
  }, [data]);

  // const [form] = Form.useForm();

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <Space direction="vertical" style={{ width: '100%' }} align="center">
        <ButtonPartsLink24 />
      </Space>

      {/* <PurchasesPartsLink form={form} /> */}
    </DefaultRouteTabs>
  );
}
export default PurchasingPartsLinkPage;
